export { default as MinusSmSolidIcon } from './MinusSmSolidIcon';
